<template>
    <form @submit.prevent="createReport">
        <grid class="c-m g-m">
            <row class="c-m" :reverse="!1" end="xs" middle="xs">
                <column :xs="3">
                    <i class="far fa-file-chart-line fa-3x"></i>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" :placeholder="$t('reports.name_label')" :value="report.name" name="name" @input="setReport" type="text" required>
                </column>
                <column :xs="2"></column>
            </row>
            <row class="c-m" :reverse="!1" end="xs" middle="xs">
                <column :xs="3">
                    <b>{{$t('reports.type_label')}}</b>
                </column>
                <column :xs="7">
                    <label class="dock-pull-select-label">
                        <select class="dock-pull-select" :value="report.type" @input="setReport" name="type">
                            <option selected>{{$t('reports.type.points')}}</option>
                            <option>{{$t('reports.type.geo')}}</option>
                            <option>{{$t('reports.type.offline_days')}}</option>
                        </select>
                    </label>
                </column>
                <column :xs="2"></column>
            </row>
            <row class="c-m" :reverse="!1" end="xs" middle="xs">
                <column :xs="3">
                    <b>{{$t('reports.objects_label')}}</b>
                </column>
                <column :xs="7">
                    <label class="dock-pull-select-label">
                        <select class="dock-pull-select">
                            <option v-bind:key="obj.id" v-for="obj in tree">{{obj.text}}</option>
                        </select>
                    </label>
                </column>
                <column :xs="2"></column>
            </row>
            <row class="c-m" center="xs" middle="xs">
                <column :xs-offset="12">
                    <button class="dock-pull-button" type="submit">{{$t('reports.add.create_label')}}</button>
                </column>
            </row>
        </grid>
    </form>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'NewReport',
  computed: {
    ...mapGetters({
      report: 'getAddReport',
      treeRecycle: 'treeRecycle'
    }),
    tree () {
      // todo add tree select view
      return this.treeRecycle('', 'name', true)
    }
  },
  methods: {
    ...mapMutations(['updateAddReport']),
    ...mapActions(['pushReport']),
    setReport (e) {
      this.updateAddReport({
        prop: e.target.name,
        value: e.target.value
      })
    },
    createReport (e) {
      this.pushReport(e)
      this.$router.push({name: 'settings_reports'})
    }
  },
  created () {
    console.log(this.tree)
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/NewReport.vue